import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Normaliza para búsqueda: minúsculas + sin acentos/diacríticos.
// Permite que "Café" encuentre "Cafe" y viceversa.
export function normSearch(v) {
  if (v === null || v === undefined) return "";
  return String(v).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
